// **********************************
//  * Third party scripts
// **********************************

import "./third-party/nv.d3.min.js";
import "./third-party/wootric-sdk.js";

// **********************************
//  * Set Up Project
// **********************************

import "./app.controller";
import "./admin.controller";
import "./leader.controller";
import "./env-set-up";

// **********************************
// * Project
// **********************************

import "./data-provider";
import "./services";
import "./models";
import "./shared";
import "./utils";
import "./helper";
import "./components";

import "./third-party/angular-google-maps.js";
// TODO: import src code with require.context, so that the index.ts files in the directories are not needed anymore
// regEx needs to import all ts file except of the index. files and the spec files
